import { render } from "./page-list-last-balance.vue?vue&type=template&id=4c7d6c61&scoped=true&ts=true"
import script from "./page-list-last-balance.vue?vue&type=script&lang=ts"
export * from "./page-list-last-balance.vue?vue&type=script&lang=ts"

import "./page-list-last-balance.vue?vue&type=style&index=0&id=4c7d6c61&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d6c61"]])

export default __exports__